module.exports = __webpack_public_path__ + "static/media/teaching-quote.260218c9.png";